<div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
	<ms-page-title />

	<!-- Page Header -->
	<div class="page-title-wrapper">
		<div>
			<!-- Search Input Group -->
			<div class="input-group position-relative">
				<input id="search" type="text" class="form-control form-control-solid pe-5"
					placeholder="Search Members" aria-label="Search Members"
					[ngModel]="searchTermInput()" (ngModelChange)="searchTermInput.set($event)"
					(keyup.enter)="applySearch()" aria-describedby="search-description">

				@if (searchTermInput()) {
					<button class="btn btn-link position-absolute top-50 translate-middle-y p-0 border-0 bg-transparent mx-2 input-group-clear-button"
						type="button" (click)="clearSearch()" aria-label="Clear search">
						<fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.4" size="lg" />
					</button>
				}

				<div class="input-group-append">
					<button class="btn btn-primary rounded-0 rounded-end" type="button" (click)="applySearch()">
						Search
					</button>
				</div>
			</div>
			<!-- Search Input Group -->
			<div id="search-description" class="ps-2 mt-2 text-muted small fst-italic">
				Search by name or email address
			</div>
		</div>
	</div>

	@if (errorMessage()) {
		<div class="alert alert-danger d-flex ms-icon-text gap-2" role="alert">
			<fa-duotone-icon icon="circle-exclamation" secondaryOpacity="0.4" />
			<div>{{ errorMessage() }}</div>
		</div>
	}

	<!-- No card wrapper: the member cards are the cards, and nesting them inside another one boxed the
	     whole grid in a second border. placeholder-glow has to stay — it drives the skeleton shimmer. -->
	<div class="mb-4 placeholder-glow">
		@if (showEmptyState()) {
			<div class="text-center text-muted py-4">
				<fa-duotone-icon icon="address-book" secondaryOpacity="0.4" class="fs-1 d-block mb-2" />
				@if (hasAppliedSearchTerm()) {
					<p class="mb-1">No members match your search.</p>
					<p class="small mb-0">Try a different name, or clear the search to see everyone.</p>
				} @else {
					<p class="mb-1">No members to show yet.</p>
					<p class="small mb-0">Members appear here once they join and choose to be listed.</p>
				}
			</div>
		} @else {
			<div class="member-directory-grid">
				@for (entry of displayEntries(); track entry.memberId) {
					<div class="card h-100 border directory-card">
						<div class="card-body d-flex flex-column align-items-center text-center py-4">
							<!-- isSelectable=false: nothing listens to (clicked) here, so the avatar must not
							     offer a pointer cursor or a "Select {name}" checkbox for an action it cannot do. -->
							<ms-avatar [identity]="entry" [avatarSize]="avatarSize" [avatarShape]="avatarShape"
								[avatarAdditionalAttributes]="avatarAdditionalAttributes"
								[isLoading]="isInitialLoad()" [showUploadControls]="false" [isSelectable]="false" />

							<span class="directory-name fs-5 fw-semibold mt-3 w-100 text-truncate" [class.placeholder]="isInitialLoad()"
								[msTooltip]="fullName(entry)" msTooltipOnlyIfTruncated>
								{{ fullName(entry) }}
							</span>

							<div class="directory-contact-line text-muted mt-2 w-100 text-truncate" [class.placeholder]="isInitialLoad()"
								[msTooltip]="entry.emailAddress ?? ''" msTooltipOnlyIfTruncated>
								{{ entry.emailAddress | noValue: '' }}
							</div>

							<div class="directory-contact-line text-muted mt-1 w-100 text-truncate" [class.placeholder]="isInitialLoad()"
								[msTooltip]="phoneLine(entry)" msTooltipOnlyIfTruncated>
								{{ phoneLine(entry) | noValue: '' }}
							</div>
						</div>
					</div>
				}
			</div>

			@if (showSentinel()) {
				<div class="directory-load-more-sentinel" ms-in-view-port (inViewPort)="onSentinelInView()"></div>
			}
		}
	</div>
</div>
